import { FC } from 'react';
import styles from './SubscribeSection.module.scss';
import { ITheme } from '@/src/lib/types/themeInterface';
import Wrapper from '@/src/components/ui/wrapper/Wrapper';
import subscribeSectionImg from '@/public/images/themes/subscribeSection/subscribe-section.webp';
import NextImage from '@/src/components/ui/nextImage/NextImage';
import classNames from 'classnames';
import Button from '@/src/components/ui/button/Button';
import SubscribeForm from '@/src/components/ui/subscribeForm/SubscribeForm';

interface ISubscribeSection {
  themeSlug?: ITheme['slug'];
  colorScheme?: 'dark' | 'grey';
  className?: string;
}

const SubscribeSection: FC<ISubscribeSection> = ({
  themeSlug,
  colorScheme = 'dark',
  className,
}) => {
  return (
    <section
      className={classNames(
        styles.subscribeSection,
        styles[`subscribeSection--${colorScheme}`],
        className
      )}>
      <Wrapper>
        <div className={styles.subscribeSection__container}>
          <div className={styles.subscribeSection__main}>
            <div className={styles.subscribeSection__content}>
              <h2 className={'heading__2'}>Be the First to Know</h2>
              <p className={styles.subscribeSection__desc}>
                New theme releases, performance updates, store growth guides, and curated industry
                resources — delivered to your inbox before everyone else.
              </p>
            </div>
            <SubscribeForm colorScheme={colorScheme} theme={themeSlug} />
          </div>
          <div className={styles.subscribeSection__imgWrapper}>
            <NextImage
              src={subscribeSectionImg.src}
              alt={'Subscribe Section'}
              fill
              sizes="(max-width: 414px) calc(100vw - 2.5rem), (max-width: 576px) calc(100vw - 3rem), (max-width: 1024px) calc(100vw - 4rem), (max-width: 1200px) calc(100vw - 634px), (max-width: 1360px) calc(100vw - 650px), (max-width: 1480px) calc(100vw - 690px), (max-width: 1580px) calc(100vw - 738px), (max-width: 1700px) calc(100vw - 758px), 870px"
            />
          </div>
        </div>
      </Wrapper>
    </section>
  );
};

export default SubscribeSection;
